/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useMemo, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {
  fetchData,
  fetchFormData,
  getEncryptedRoute,
  getTranslatedValue,
  hasSpecialCharacters,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../../reusable'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'

import 'react-datepicker/dist/react-datepicker.css'
import { ToastContainer } from 'react-toastify'
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete'
import { AddVendor } from './addvendor'
import { PersonalDetails } from './PersonalDetail'
import { PasswordMeterComponent } from '../../../../_metronic/assets/ts/components'
import moment from 'moment'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { usePermissions } from '../../contexts/PermissionContext'
import { useLang } from '../../../../_metronic/i18n/Metronici18n'

const VendorPopup = (props: any) => {
  let t = Tr()

  const [addVendorId, setAddVendorId] = useState('')
  const [selectedTab, setSelectedTab] = useState(1)
  // vendor add states
  const [imageUrl, setImageUrl] = useState('')
  const [profilePicture, setProfilePicture] = useState()
  const [fullName, setFullName] = useState('')
  const [businessName, setBusinessName] = useState('')
  const [countryCode, setCountryCode] = useState('uz')
  const [mobileNumber, setMobileNumber] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
  const [address, setAddress] = useState('')
  const [value, setValue] = useState(null)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  var locationreff = useRef(null)
  const [longitude, setLongitude] = useState('')
  const [latitude, setLatitude] = useState('')
  const [loading, setLoading] = useState(false)
  const [passwordDisplay, setPasswordDisplay] = useState(false)
  const [confirmPasswordDisplay, setConfirmPasswordDisplay] = useState(false)

  // category list state start
  const [categoryList, setCategoryList] = useState([])
  const [categorySelectedOptions, setCategorySelectedOptions] = useState<any>([])
  var categoryId = categorySelectedOptions.value

  // set error state
  const [error, setError] = useState([
    {
      profilePicture: '',
      fullName: '',
      businessName: '',
      phoneNumber: '',
      email: '',
      address: '',
      password: '',
      confirmPassword: '',
      categoryId: '',
    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  const handleChange = (value: any, country: any, e: any, formate: any) => {
    setPhoneNumber(value) // set mobile number default value
    removeError('phoneNumber') // remove error message
    const parts = formate.split(' ')
    const formattedValue = parts.slice(1).join(' ').replace(/\D/g, '')
    setCountryCode(country.dialCode) // get country code
    setMobileNumber(formattedValue) // get mobile number without country code
  }
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]
    let firstErrorField = null

    if (profilePicture == undefined || profilePicture == null || profilePicture == undefined) {
      errorTmp[0].profilePicture = t('Profile Picture Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'profilePicture'
    }
    if (fullName.trim() == '' || fullName == null || fullName == undefined) {
      errorTmp[0].fullName = t('Full Name Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'fullName'
    }

    if (
      categorySelectedOptions == '' ||
      categorySelectedOptions == null ||
      categorySelectedOptions == undefined
    ) {
      errorTmp[0].categoryId = t('Service Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'categoryId'
    }
    if (phoneNumber == '' || phoneNumber == undefined || phoneNumber == null) {
      errorTmp[0].phoneNumber = t('Mobile Number Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'phoneNumber'
    } else if (!Number(phoneNumber)) {
      errorTmp[0].phoneNumber = t('Only Numbers Are allowed.')
      isValid = false
      if (!firstErrorField) firstErrorField = 'phoneNumber'
    } else if (
      ((phoneNumber != '' && phoneNumber != undefined) || phoneNumber != null) &&
      phoneNumber.length < 8
    ) {
      errorTmp[0].phoneNumber = t('Minimum 8 Digit Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'phoneNumber'
    }
    if (email == '' || email == undefined || email == null) {
      errorTmp[0].email = t('Email Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'email'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
      errorTmp[0].email = t('Email Is Not Valid.')
      isValid = false
      if (!firstErrorField) firstErrorField = 'email'
    }

    if (password.trim() == '' || password == undefined || password == null) {
      errorTmp[0].password = t('Password Is Requried')
      isValid = false
      if (!firstErrorField) firstErrorField = 'password'
    } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(password)) {
      errorTmp[0].password = t('Use 8 or more characters with a mix of letters, numbers & symbols.')
      isValid = false
      if (!firstErrorField) firstErrorField = 'password'
    }
    if (confirmPassword.trim() == '' || confirmPassword == null || confirmPassword == undefined) {
      errorTmp[0].confirmPassword = t('Confirm Password Is Required.')
      isValid = false
      if (!firstErrorField) firstErrorField = 'confirmPassword'
    } else if (password != confirmPassword) {
      errorTmp[0].confirmPassword = t("Passwords Don't Match")
      isValid = false
      if (!firstErrorField) firstErrorField = 'confirmPassword'
    }

    setError(errorTmp)
    // If there was a validation error, scroll to the first error field
    if (!isValid && firstErrorField) {
      const element = document.getElementById(firstErrorField)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
    return isValid
  }

  // vendor register
  const registrationApi = async () => {
    if (validate()) {
      var adminData: any = sessionStorage.getItem('admin')
      adminData = JSON.parse(adminData)

      let param = new FormData()
      param.append('fullName', fullName)
      param.append('categoryId', categoryId)
      param.append('countryCode', countryCode)
      param.append('mobileNumber', mobileNumber)
      param.append('email', email)
      param.append('password', password)
      param.append('updatedBy', adminData['adminId'])

      if (profilePicture) {
        param.append('logo', profilePicture)
      }
      if (
        addVendorId != '' &&
        addVendorId != null &&
        addVendorId != '0' &&
        addVendorId != undefined
      ) {
        param.append('vendorId', addVendorId)
      }
      var res = await fetchFormData('admin/addEditVendor', param)
      if (res.status == '200') {
        setTimeout(() => {
          if (
            addVendorId == '' ||
            addVendorId == null ||
            addVendorId == undefined ||
            addVendorId == '0'
          ) {
            setAddVendorId(res.data.length > 0 ? res.data[0]['vendorId'] : res.data['vendorId'])
            toastsuccessmsg('Vendor Add Successfully')
          } else {
            toastsuccessmsg('Vendor Updated Successfully')
          }
          setSelectedTab(2)
        }, 500)
      } else {
        toasterrormsg(res.message)
      }
    }
  }

  //  category list api call
  const categoryAPIcall = async () => {
    var res = await fetchData('vendor/public/categoryList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({
          value: val.categoryId, label: getTranslatedValue(props.lang, val, '_name')
        })
      })

      setCategoryList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  const findadd = (address: any) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((value: any) => {
        setLatitude(value.lat)
        setLongitude(value.lng)
        setAddress(address)
      })
  }
  useEffect(() => {
    PasswordMeterComponent.bootstrap()
    categoryAPIcall()
    countryListAPIcall()
  }, [])

  const setvendor = async (id: any) => {
    setAddVendorId(id)
    setSelectedTab(2)
  }

  const changeTab2 = () => {
    if (validate() && addVendorId != '' && addVendorId != null && addVendorId != undefined) {
      setSelectedTab(2)
    }
  }

  const [disable, setDisable] = useState(false)
  const [ownerName, setOwnerName] = useState('')
  const [businessRegistration, setBusinessRegistration] = useState() as any
  const [businessRgst, setBusinessRgst] = useState('')
  const [region, setRegion] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [addressLine1, setAddressLine1] = useState('')
  const [addressLine2, setAddressLine2] = useState('')
  const [countryList, setCountryList] = useState([])
  const [countrySelectedOptions, setCountrySelectedOptions] = useState<any>()
  const [regionList, setRegionList] = useState([])
  const [regionSelectedOptions, setRegionSelectedOptions] = useState<any>([])
  // set error state
  const [personalDetailError, setPersonalDetailError] = useState([
    {
      ownerName: '',
      businessName: '',
      country: '',
      // region: '',
      regionId: '',
      zipCode: '',
      addressLine1: '',
      businessRegistration: '',
    },
  ])

  // remove validation function
  const personalDetailRemoveError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  const countryListAPIcall = async () => {
    var res = await fetchData('vendor/public/countryList', [])

    if (res.status == '200') {
      var opt: any = []      
      res.data.map((val: any) => {
        opt.push({ value: val.countryId, label: val.nicename })
      })

      setCountryList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }
  const regionListAPIcall = async () => {
    var res = await fetchData('vendor/public/regionList', [])

    if (res.status == '200') {
      var opt: any = []
      console.log(res.data);
      
      res.data.map((val: any) => {
        opt.push({ value: val.regionId, label:getTranslatedValue(props.lang, val, '_name') })
      })

      setRegionList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  // validation function
  const vendorPersonaldetailvalidate = () => {
    var isValid = true
    var errorTmp = [...personalDetailError]
    let firstErrorField = null
    if (addVendorId == '' || addVendorId == null || addVendorId == undefined) {
      isValid = false
      toasterrormsg('Please Fill Vendor Detail In Previous Step')
    }
    if (ownerName.trim() == '' || ownerName.trim() == null || ownerName.trim() == undefined) {
      errorTmp[0].ownerName = t('Owner Name Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'ownerName'
    } else if (!hasSpecialCharacters(ownerName.trim())) {
      errorTmp[0].ownerName = t('Special Characters Are Not Allowed')
      isValid = false
      if (!firstErrorField) firstErrorField = 'ownerName'
    }
    if (
      businessName.trim() == '' ||
      businessName.trim() == null ||
      businessName.trim() == undefined
    ) {
      errorTmp[0].businessName = t('Business Name Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'businessName'
    }
    if (
      countrySelectedOptions == '' ||
      countrySelectedOptions == null ||
      countrySelectedOptions == undefined
    ) {
      errorTmp[0].country = t('Country Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'country'
    }
    if (
      regionSelectedOptions == undefined ||
      regionSelectedOptions == '' ||
      regionSelectedOptions == null
    ) {
      errorTmp[0].regionId = t('Region Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'region'
    }
    if (
      addressLine1.trim() == '' ||
      addressLine1.trim() == null ||
      addressLine1.trim() == undefined
    ) {
      errorTmp[0].addressLine1 = t('Address Line1 Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'addressLine1'
    }
    if (zipCode.trim() == '' || zipCode.trim() == null || zipCode.trim() == undefined) {
      errorTmp[0].zipCode = t('Zip Code Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'zipCode'
    }
    if (!businessRgst) {
      if (
        businessRegistration == undefined ||
        businessRegistration == null ||
        businessRegistration == undefined
      ) {
        errorTmp[0].businessRegistration = t('Business Registration Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'businessRegistration'
      }
    }

    setPersonalDetailError(errorTmp)
    // If there was a validation error, scroll to the first error field
    if (!isValid && firstErrorField) {
      const element = document.getElementById(firstErrorField)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
    return isValid
  }

  const fileTypes = ['JPEG', 'JPG', 'PNG', 'PDF']

  const handleBusinessRegistrationChange = (file: any) => {
    if (file) {
      if (!file.type.startsWith('image/') && file.type != 'application/pdf') {
        // Invalid file type
        // Handle error or display a message
        toasterrormsg('Invalid file type. Please upload only image or pdf files.')
        setBusinessRegistration(undefined)

        return
      }
      // Handle business registration file change
      // For example:
      setBusinessRegistration(file)
      removeError('businessRegistration')
    } else {
    }
  }
  const handleDivClick = (inputId: string) => {
    const inputElement = document.getElementById(inputId)
    if (inputElement) {
      inputElement.click()
    }
  }

  // add business details api call
  const addBusinessDetailsApi = async () => {
    if (vendorPersonaldetailvalidate()) {
      var admindata: any = sessionStorage.getItem('admin')
      admindata = JSON.parse(admindata)
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('vendorId', addVendorId)
      param.append('propertyOwnerName', ownerName)
      param.append('bussinessName', businessName)
      param.append('country', countrySelectedOptions.value)
      param.append('region', regionSelectedOptions.value)
      param.append('addressline1', addressLine1)
      param.append('addressline2', addressLine2)
      param.append('zipcode', zipCode)
      param.append('adminId', admindata['adminId'])

      if (businessRegistration) {
        param.append('businessDocument', businessRegistration)
      }
      var response: any = await fetchFormData('vendor/public/businessInformation', param)
      if (response.status == '200') {
        toastsuccessmsg('Business Information Saved Successfully!')
        const state = {
          vendorId: props.vendorId,
        }
        setTimeout(() => {
          setDisable(false)
          setLoading(false)
          props.onHide()
        }, 1500)
      } else {
        toasterrormsg(response.message)
        setDisable(false)
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    countryListAPIcall()
    regionListAPIcall()
  }, [])

  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-hcenter'
      dialogClassName='maxwidth1000px'
      centered
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header closeButton>
        <label className='h3'>{t('Add Vendor')}</label>
      </Modal.Header>
      <Modal.Body>
        <ToastContainer />
        <div
          className='stepper stepper-links d-flex flex-column'
          id='kt_create_account_stepper'
          data-kt-stepper='true'
        >
          <div className='stapper d-flex justify-content-center mb-5'>
            <span
              className={`btn me-2 btn-wave waves-effect  ${selectedTab == 1 ? 'waves-light text-white greenbtn' : ''
                }`}
              onClick={() => {
                setSelectedTab(1)
              }}
              title={t('Basic Detail')}
            >
              {t('Basic Detail')}
            </span>
            <span
              className={`btn me-2 ${selectedTab == 2 ? 'waves-light text-white greenbtn' : ''}`}
              title='Personal Informatioin'
              onClick={() => {
                changeTab2()
              }}
            >
              {t('Business Information')}
            </span>
          </div>

          {selectedTab == 1 && (
            <AddVendor
              setvendor={setvendor}
              onHide={props.onHide}
              imageUrl={imageUrl}
              setImageUrl={setImageUrl}
              profilePicture={profilePicture}
              setProfilePicture={setProfilePicture}
              fullName={fullName}
              setFullName={setFullName}
              businessName={businessName}
              setBusinessName={setBusinessName}
              countryCode={countryCode}
              setCountryCode={setCountryCode}
              mobileNumber={mobileNumber}
              setMobileNumber={setMobileNumber}
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
              email={email}
              setEmail={setEmail}
              address={address}
              setAddress={setAddress}
              value={value}
              setValue={setValue}
              password={password}
              setPassword={setPassword}
              confirmPassword={confirmPassword}
              setConfirmPassword={setConfirmPassword}
              longitude={longitude}
              setLongitude={setLongitude}
              latitude={latitude}
              setLatitude={setLatitude}
              loading={loading}
              setLoading={setLoading}
              passwordDisplay={passwordDisplay}
              setPasswordDisplay={setPasswordDisplay}
              confirmPasswordDisplay={confirmPasswordDisplay}
              setConfirmPasswordDisplay={setConfirmPasswordDisplay}
              categorySelectedOptions={categorySelectedOptions}
              setCategorySelectedOptions={setCategorySelectedOptions}
              registrationApi={registrationApi}
              findadd={findadd}
              handleChange={handleChange}
              categoryList={categoryList}
              error={error}
              removeError={removeError}
              zipCode={zipCode}
              setZipCode={setZipCode}
              addressLine1={addressLine1}
              setAddressLine1={setAddressLine1}
              addressLine2={addressLine2}
              setAddressLine2={setAddressLine2}
              countryList={countryList}
              regionList={regionList}
              setRegionSelectedOptions={setRegionSelectedOptions}
              regionSelectedOptions={regionSelectedOptions}
              countrySelectedOptions={countrySelectedOptions}
              setCountrySelectedOptions={setCountrySelectedOptions}
              businessRgst={businessRgst}
              setBusinessRgst={setBusinessRgst}
              businessRegistration={businessRegistration}
              setBusinessRegistration={setBusinessRegistration}
            />
          )}
          {selectedTab == 2 && (
            <PersonalDetails
              vendorId={addVendorId}
              onHide={props.onHide}
              loading={loading}
              setLoading={setLoading}
              disable={disable}
              setDisable={setDisable}
              ownerName={ownerName}
              setOwnerName={setOwnerName}
              businessName={businessName}
              setBusinessName={setBusinessName}
              businessRegistration={businessRegistration}
              setBusinessRegistration={setBusinessRegistration}
              businessRgst={businessRgst}
              setBusinessRgst={setBusinessRgst}
              zipCode={zipCode}
              setZipCode={setZipCode}
              addressLine1={addressLine1}
              setAddressLine1={setAddressLine1}
              addressLine2={addressLine2}
              setAddressLine2={setAddressLine2}
              countryList={countryList}
              regionList={regionList}
              setRegionSelectedOptions={setRegionSelectedOptions}
              regionSelectedOptions={regionSelectedOptions}
              setCountryList={setCountryList}
              countrySelectedOptions={countrySelectedOptions}
              setCountrySelectedOptions={setCountrySelectedOptions}
              handleBusinessRegistrationChange={handleBusinessRegistrationChange}
              validate={vendorPersonaldetailvalidate}
              handleDivClick={handleDivClick}
              addBusinessDetailsApi={addBusinessDetailsApi}
              removeError={personalDetailRemoveError}
              error={personalDetailError}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export function VendorList(props: any) {
  let t = Tr()
  const [showPopup, setShowPopup] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)
  const { menuId, menuIdAdd, menuIdEdit } = useMenuIdPermissions()
    const lang = useLang()


  ///////
  const [vendorList, setVendorList] = useState([])
  const [orgVendorList, setOrgVendorList] = useState([])
  const [vendorId, setvendorId] = useState('')

  const detailPath = getEncryptedRoute('../../vendordetail/personaldetail', { menuId: menuId })
  // DataTable columns
  var vendorcolumn = useMemo(
    () => [
      {
        name: t('Name'),
        cell: (row: any) => (
          <Link
            to={menuIdEdit ? detailPath : ''}
            onClick={() => {
              sessionStorage.setItem('locationVendorId', btoa(row.vendorId))
            }}
          >
            <div className='my-3 d-flex align-items-center cursor-pointer'>
              <div className='me-2'>
                {/* <img
                  className='rounded-circle h-30px w-30px'
                  loading='lazy' // Enables browser-native lazy loading
                  src={row.logo}
                  alt=''
                /> */}
              </div>
              {row.fullName}
            </div>
          </Link>
        ),
        sortable: true,
        selector: (row: any) => String(row.fullName),
        filter: true,
        width: '200px',
      },
      {
        name: t('Service Type'),
        cell: (row: any) => <div className='my-3'>{getTranslatedValue(lang, row, '_name') != '' ? getTranslatedValue(lang, row, '_name') : '-'}</div>,
        selector: (row: any) => getTranslatedValue(lang, row, '_name'),
        sortable: true,
        filter: true,
        width: '220px',
      },
      {
        name: t('Email'),
        cell: (row: any) => <div className='my-3'>{row.email != '' ? row.email : '-'}</div>,
        sortable: true,
        selector: (row: any) => String(row.email),
        filter: true,
        width: '220px',
      },

      {
        name: t('Mobile Number'),
        cell: (row: any) => (
          <div className='my-3'>
            {'+' +
              (row.countryCode != '' ? row.countryCode : '') +
              ' ' +
              (row.mobileNumber != '' ? row.mobileNumber : '')}
          </div>
        ),
        selector: (row: any) =>
          (row.countryCode ? row.countryCode : '-') +
          ' ' +
          (row.mobileNumber ? row.mobileNumber : '-'),
        sortable: true,
        filter: true,
        width: '180px',
      },
      {
        name: t('Number of Property'),
        cell: (row: any) => (
          <div className='my-3'>{row.propertyCount != '' ? row.propertyCount : '-'}</div>
        ),
        selector: (row: any) => row.propertyCount,
        sortable: true,
        filter: true,
        width: '180px',
      },
      {
        name: t('Submitted Date'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.submitDate == '' || row.submitDate == null
              ? '-'
              : moment(row.submitDate, ['YYYY-MM-DD']).format('DD-MM-YYYY')}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.submitDate),
        sortFunction: (rowA: any, rowB: any) => {
          const dateA = rowA.submitDate ? new Date(rowA.submitDate) : null
          const dateB = rowB.submitDate ? new Date(rowB.submitDate) : null

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0 // Both dates are empty
          if (!dateA) return 1 // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1 // Ascending
          if (dateA > dateB) return 1 // Descending
          return 0
        },
        filter: true,
        width: '180px',
      },
      {
        name: t('Verified Date'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.verifiedDate == '' || row.verifiedDate == null
              ? '-'
              : moment(row.verifiedDate, ['YYYY-MM-DD']).format('DD-MM-YYYY')}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.verifiedDate),
        sortFunction: (rowA: any, rowB: any) => {
          const dateA = rowA.verifiedDate ? new Date(rowA.verifiedDate) : null
          const dateB = rowB.verifiedDate ? new Date(rowB.verifiedDate) : null

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0 // Both dates are empty
          if (!dateA) return 1 // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1 // Ascending
          if (dateA > dateB) return 1 // Descending
          return 0
        },
        filter: true,
        width: '180px',
      },

      {
        name: t('Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              <input
                className='form-check-input cursor-pointer'
                type='checkbox'
                value='1'
                title={row.block == 0 ? 'Active' : 'Inactive'}
                checked={row.block == 0 ? true : false}
                onChange={() => changeStatus(row.vendorId, !row.block)}
              />
            </label>
          </div>
        ),
        sortable: false,
        filter: false,
        width: '100px',
      },
      {
        name: t('Verify'),
        cell: (row: any) => (
          <div className='my-3'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              {row.businessInfostatus == 0 ? (
                <span className='badge badge-warning mx-2'>{t('Pending')}</span>
              ) : row.businessInfostatus == 1 ? (
                <span className='badge badge-success mx-2'>{t('Verified')}</span>
              ) : (
                <span className='badge badge-danger mx-2'>{t('Rejected')}</span>
              )}
            </label>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.businessInfostatus),
        filter: true,
        width: '150px',
      },
    ],
    [detailPath, t]
  )
  // data table custome style
  const customStyles = {
    headRow: {
      style: {
        fontWeight: 'bold',
        fontSize: '16px',
      },
    },
  }

  // change vendor status
  const changeStatus = async (vendorId: any, status: any) => {
    var tmp2 = sessionStorage.getItem('admin')
    // Step 2: Check if the item is not null
    if (tmp2) {
      // Step 3: Parse the JSON string
      var adminData = JSON.parse(tmp2)
      // Step 4: Access the adminId
      var adminId = adminData.adminId
    }
    var param: any = {
      vendorId: vendorId,
      status: status == true ? 1 : 0,
      adminId: adminId,
    }

    var res = await fetchData('admin/vendorStatus', param)

    if (res.status == '200') {
      vendorlistapi()
      toastsuccessmsg(res.message)
    } else {
      toasterrormsg(res.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Vendors'

    vendorlistapi()
    localStorage.removeItem('categoryId')
  }, [])

  // data table custome header
  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }

    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Vendor')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
          {/* Filtre Start --- */}

          {/* begin::Add Department */}
          {menuIdAdd ? (
            <button
              type='button'
              className='btn btn-success monthBtn'
              onClick={() => setShowPopup(true)}
            >
              <KTIcon iconName='plus' className='fs-2' />
              {t('Add Vendor')}
            </button>
          ) : (
            ''
          )}
          {/* end::Add Department */}
        </div>
      </div>
    )
  }

  // vendor list API call
  const vendorlistapi = async () => {
    var param: any = {}
    if (props.block != undefined && props.block != null && props.block != '') {
      param['block'] = props.block
    }
    if (props.status != undefined && props.status != null && props.status != '') {
      param['status'] = props.status
    }
    var response: any = await fetchData('admin/vendorList', param)

    if (response.status == '200') {
      let data = response.data
      setOrgVendorList(data)
      setVendorList(data)
    } else {
      toasterrormsg(response.message)
    }
  }

  // search function
  const usersearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setVendorList(orgVendorList)
    } else {
      var tmp: any = orgVendorList.filter((item: any) => {
        var mobile: any = item.mobileNumber
        if (mobile != null && item.mobile != '') {
        }

        return (
          (item.fullName != null &&
            item.fullName != '' &&
            item.fullName.toLowerCase() == text.toLowerCase()) ||
          (item.fullName != null &&
            item.fullName != '' &&
            item.fullName.toLowerCase().includes(text.toLowerCase())) ||
          (item.email != null &&
            item.email != '' &&
            item.email.toLowerCase() == text.toLowerCase()) ||
          (item.email != null &&
            item.email != '' &&
            item.email.toLowerCase().includes(text.toLowerCase())) ||
          (item.businessInfostatus != null &&
            item.businessInfostatus != '' &&
            String(item.businessInfostatus).toLowerCase().includes(text.toLowerCase())) ||
          (item.en_name != null &&
            item.en_name != '' &&
            String(item.en_name).toLowerCase().includes(text.toLowerCase())) ||
          (item.mobileNumber != null &&
            item.mobileNumber != '' &&
            String(item.mobileNumber).toLowerCase().includes(text.toLowerCase()))
        )
      })

      setVendorList(tmp)
    }
  }

  // add vendor popup

  return (
    <>
      <ToastContainer />
      <div className='card'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgVendorList.length > 0 ? (
              <>
                <DataTable
                  columns={vendorcolumn}
                  data={vendorList}
                  customStyles={customStyles}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader search={searchTerm} isfoc={focus} customSearch={usersearch} />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column my-10 py-20'>
                    <h2 className='fs-2x fw-bold mb-10'>{t('Welcome To Vendor')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold mb-10'>{t('There are no Vendor')}</p>
                  {menuIdAdd ? (
                    <Link
                      to='#'
                      className='btn btn-success monthBtn'
                      onClick={() => setShowPopup(true)}
                    >
                      {t('Add Vendor')}
                    </Link>
                  ) : (
                    ''
                  )}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        {showPopup && (
          <VendorPopup
            show={showPopup}
            vendorId={vendorId}
            lang={lang}
            onHide={() => {
              setShowPopup(false)
              vendorlistapi()
            }}
          />
        )}
      </div>
    </>
  )
}
